import { render, staticRenderFns } from "./ModalTeacherMedia.vue?vue&type=template&id=1f802319&scoped=true&"
import script from "./ModalTeacherMedia.vue?vue&type=script&lang=js&"
export * from "./ModalTeacherMedia.vue?vue&type=script&lang=js&"
import style0 from "./ModalTeacherMedia.vue?vue&type=style&index=0&id=1f802319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f802319",
  null
  
)

export default component.exports